"use client";

import Image from "next/image";
import { Container } from "./Container";
import { useIntlRouter } from "@/lib/utils/navigation";
import { useTranslations } from "next-intl";

export default function CallToActionBanner() {
  const t = useTranslations();
  const router = useIntlRouter();

  return (
    <div className="bg-[#F9E0DC] w-full overflow-hidden relative">
      {/* Left Character - positioned absolutely from left edge */}
      <div className="absolute left-[-120px] top-[100px] bottom-0 flex items-center">
        <Image
          src="/assets/image/wait-pink.png"
          alt="Macaron character"
          width={390}
          height={390}
          className="object-contain -translate-x-6 md:block hidden"
        />
      </div>

      {/* Right Character - positioned absolutely from right edge */}
      <div className="absolute right-0 top-0 bottom-[-200px] flex items-center">
        <Image
          src="/assets/image/wait-orange.png"
          alt="Macaron character"
          width={260}
          height={260}
          className="object-contain translate-x-6 md:block hidden"
        />
      </div>

      <Container>
        <div className="py-16">
          {/* Center Content */}
          <div className="text-center px-8 relative z-10">
            <h2
              className="text-[24px] lg:text-[46px] md:text-[32px] text-[#161615] mb-6"
              style={{
                fontWeight: "600",
              }}
            >
              {t("blog.applyToBecome")}{" "}
              <span
                className="text-[#161615] text-[24px] lg:text-[46px] md:text-[32px]"
                style={{
                  fontWeight: "400",
                }}
              >
                {t("blog.macaronsFirstFriends")}
              </span>
            </h2>
            <button
              className={`w-full mt-[40px] md:mt-[60px] flex items-center justify-center relative transition-all duration-200 ease-in-out transform
          ${"cursor-pointer hover:scale-105 active:scale-95"}`}
              onClick={() => {
                router.push("/");
              }}
              disabled={false}
            >
              <img
                src="/assets/image/wait-button.png"
                alt="Macaron"
                className="w-[200px] md:w-[237px] h-auto absolute"
              />
              <div className="z-10 text-[18px] md:text-[20px] leading-[22px] font-[600] text-white">
                {t("blog.findMyAIFriend")}
              </div>
            </button>
          </div>
        </div>
      </Container>
    </div>
  );
}
